module.exports = __webpack_public_path__ + "media/images/flags/32/United-Kingdom-38bbf732513d02807aac25bd37b585f4.png";